// @ts-strict-ignore
import { Connection } from '../../model3d/connection';
import { Rectangle3D } from '../../model/rectangle-3d';
import { Vector3 } from 'three';
import { ConnectionSortGroup } from '../../model3d/connection-sort-group';
import { MathUtils } from '../../common/util/math-utils';
import { Injectable } from '@angular/core';
import { AcceptingConnectionSortGroupHelper } from './accepting-connection-sort-group.helper';

@Injectable({ providedIn: 'root' })
export class BusbarConnectionSortGroupHelper extends AcceptingConnectionSortGroupHelper {

  protected addConnectionCubeInSortGroup(connectionCube: Connection, sortGroups: ConnectionSortGroup[]): void {
    const connectionRectangle: Rectangle3D = connectionCube.compositionRectangle;
    const uDirection: Vector3 = this.getSortDirection(connectionRectangle, connectionCube.articleContainer.article);
    const absUDirection: Vector3 = new Vector3(Math.abs(uDirection.x), Math.abs(uDirection.y), Math.abs(uDirection.z));
    const normal: Vector3 = MathUtils.getNormalFromFirstPoint(connectionRectangle.point1, connectionRectangle.point2, connectionRectangle.point3);

    let fittingGroup: ConnectionSortGroup = null;
    for (const group of sortGroups) {
      if (!MathUtils.equalsNumber3D(absUDirection, group.sortDirection) || !MathUtils.equalsNumber3D(normal, group.normalDirection)) {
        continue;
      }
      const groupFirstPoint: Vector3 = group.connectionFirstPoint;
      if (
        !MathUtils.isEqualsVectorsByTwoAxis(groupFirstPoint, connectionRectangle.point1) &&
        !MathUtils.isEqualsVectorsByTwoAxis(groupFirstPoint, connectionRectangle.point3)
      ) {
        continue;
      }
      let directionToPoint1: Vector3 = connectionRectangle.point1.clone().sub(groupFirstPoint);
      let directionToPoint3: Vector3 = connectionRectangle.point3.clone().sub(groupFirstPoint);
      directionToPoint1.normalize();
      directionToPoint3.normalize();
      directionToPoint1 = new Vector3(Math.abs(directionToPoint1.x), Math.abs(directionToPoint1.y), Math.abs(directionToPoint1.z));
      directionToPoint3 = new Vector3(Math.abs(directionToPoint3.x), Math.abs(directionToPoint3.y), Math.abs(directionToPoint3.z));
      if (MathUtils.equalsNumber3D(absUDirection, directionToPoint1) || MathUtils.equalsNumber3D(absUDirection, directionToPoint3)) {
        fittingGroup = group;
        break;
      }
    }
    if (!fittingGroup) {
      fittingGroup = new ConnectionSortGroup();
      fittingGroup.sortDirection = absUDirection;
      fittingGroup.normalDirection = normal;
      sortGroups.push(fittingGroup);
    }
    fittingGroup.connectionCubes.push(connectionCube);
  }

  protected isSameGeometricRectangles(previousRectangle: Rectangle3D, currentRectangle: Rectangle3D): boolean {
    return true;
  }
}
